import * as Api from '@ViewModels';

// Mirrors the digest email's subject-line formula, so the card shows the same "N to review" number
// the user sees in their inbox: at-risk/negative sentiments + action items + draft replies + watchlist.
export const briefReviewCount = (digest: Api.IEmailExecDigest): number => {
	const actionableSentiments = (digest.clientSentiments ?? []).filter(
		item => item.sentiment === 'AtRisk' || item.sentiment === 'Negative'
	).length;
	return (
		actionableSentiments +
		(digest.proposedActionItems?.length ?? 0) +
		(digest.draftReplies?.length ?? 0) +
		(digest.watchlist?.length ?? 0)
	);
};

const stripInlineMarkdown = (line: string): string =>
	line
		.replace(/^([-*+]|\d+\.)\s+/, '')
		.replace(/^>\s*/, '')
		.replace(/!\[([^\]]*)\]\([^)]*\)/g, '$1')
		.replace(/\[([^\]]+)\]\([^)]*\)/g, '$1')
		.replace(/(\*\*|__)(.*?)\1/g, '$2')
		.replace(/(\*|_)(.*?)\1/g, '$2')
		.replace(/`([^`]*)`/g, '$1')
		.trim();

/** First meaningful line of the brief flattened to plain text; headings and rules are skipped. */
export const briefExcerpt = (markdown: string): string => {
	for (const rawLine of markdown.replace(/\r\n/g, '\n').split('\n')) {
		const line = rawLine.trim();
		if (!line || /^#{1,6}\s/.test(line) || /^([-_*]\s*){3,}$/.test(line)) {
			continue;
		}
		return stripInlineMarkdown(line);
	}
	return '';
};
